import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { toastAlert } from '@paylixecommerce/shared/components';
import { Switch, SimpleSelect } from "components/fields";
import { Alert, Button } from "components";
import { getGroups as getGroupsAction, newTelegramCode } from "./actions";
import useTheme from "../../../../../../../../hooks/useTheme";

import "./index.scss";


const TelegramIcon = ({}) => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 8.33594L9.16667 11.6693L14.1667 16.6693L17.5 3.33594L2.5 9.16927L5.83333 10.8359L7.5 15.8359L10 12.5026" stroke="#6A3CE2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;

const RefreshIcon = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3.375 9.16667C3.58574 7.55895 4.37518 6.08315 5.59557 5.01552C6.81595 3.94789 8.38359 3.36163 10.0051 3.36647C11.6265 3.37132 13.1906 3.96695 14.4046 5.04186C15.6186 6.11677 16.3992 7.59726 16.6003 9.20621C16.8014 10.8152 16.4093 12.4423 15.4972 13.7829C14.5852 15.1236 13.2158 16.0859 11.6455 16.4897C10.0751 16.8935 8.41136 16.7112 6.96573 15.9768C5.5201 15.2424 4.39166 14.0064 3.79167 12.5M3.375 16.6667V12.5H7.54167"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ({ form, telegramServerError, isUtils= false }) => {

    const dispatch = useDispatch();
    const shop = useSelector(({auth}) => auth.shop);
    const telegramCode = (shop || {}).telegram_code;

    const [groups, setGroups] = useState([]);
    const isDark = useTheme();

    const [loadingGroups, setLoadingGroups] = useState(false);

    const createTelegramCode = () => {
        setLoadingGroups(true);
        dispatch(newTelegramCode())
            .then(({data}) => {
                form.setFieldValue('telegram_code', data.code);
            })
            .catch(err => toastAlert('error', (err && err.error) || 'Something went wrong!'))
            .finally(() => setLoadingGroups(false));
    }

    useEffect(() => {
        if (shop && !shop.telegram_code) {
            createTelegramCode();
        }
    }, [shop]);


    useEffect(() => {
        let {telegram_group_id} = form.values;

        const findGroup = () => {
            groups.forEach(group => {
                if (group.value === telegram_group_id) {
                    form.setFieldValue('telegram_group_id', group.value);
                }
            })
        }

        if (telegram_group_id && groups.length) {
            findGroup();
        }
    }, [groups, form.values.telegram_group_id]);

    const getGroups = () => {
        setLoadingGroups(true);
        dispatch(getGroupsAction())
            .then(({data}) => {
                if ((data.groups || []).length) {
                    let groups = data.groups.map(({id: value, title: label}) => ({value, label}));
                    groups.push({value: "none", label: "None"});
                    setGroups(groups);
                } else {
                    setGroups([]);
                }
            })
            .catch(error => {
                throw error;
            })
            .finally(() => setLoadingGroups(false));
    };

    const handleRefreshGroups = () => {
        getGroups();
    }

    {/* const handleTelegramAlertClick = () => {
        const docUrl = 'https://help.paylix.gg/en/articles/8707678-how-to-use-our-telegram-bot';
        window.open(docUrl, "_blank", "popup,noopener,noreferrer,width=400,height=640");
    }
    */}

    useEffect(() => {
        if (telegramCode) {
            handleRefreshGroups();
        }
    }, [telegramCode]);

    const GroupLabel = <div className="w-100 align-items-end d-flex justify-content-between">
        <div className="d-flex flex-column">
            <div>Group</div>
        </div>

        <Button square variant="secondary" onClick={handleRefreshGroups}>
            <RefreshIcon/>
        </Button>
    </div>;

    return <div className={`${!isUtils ? 'product-form-main-back' : 'switcher-container withBorder'} pb-3`}>
        <div>
            {/* Commented out until the help article link is fixed
            {isUtils ? null : <Alert
                className="w-100 mb-4 mt-0 pt-3 pr-3 pb-3 pl-3"
                purple
                Icon={TelegramIcon}
                onClick={handleTelegramAlertClick}
                title="How to configure Telegram"
                text="Read our guide to add your Telegram groups to our integration."
            />}
            */}

            <Switch
                name="telegram_integration"
                left
                label="Enable Telegram integration"
                note="Check this option to enable our telegram integration. Customers will be able to authenticate with their Telegram account at checkout, you will also have the option to add them to one of your groups."
                wrapperClassName={isUtils ? "" : "mb-2"}
                {...form}
            />

            {!!form.values.telegram_integration &&
                <div className={isUtils ? "utils-telegram" : ""}>
                    <Switch
                        name="telegram_optional"
                        left
                        label="Optional"
                        note="Enable this option if you'd like to make the telegram integration optional for your customers. They will not be required to connect their telegram account at the moment of the checkout, but they will be prompted to."
                        wrapperClassName={isUtils ? "mb-2" : "mt-3 mb-2"}
                        {...form}
                    />

                    {telegramCode &&
                        <div className="mt-3">
                            {
                                groups.length > 0 ?
                                    <SimpleSelect
                                        showEmpty
                                        label={GroupLabel}
                                        noteUnder
                                        style={telegramServerError ? {borderColor: "var(--red6)"} : {}}
                                        disabled={loadingGroups}
                                        note="Choose the Telegram group into which the customer will be added. If the customer is already in this group, this will be skipped automatically."
                                        onChange={(e) => {
                                            form.setFieldValue('telegram_group_id', e.target.value);
                                        }}
                                        wrapperClassName="!mb-0"
                                        placeholder="Select a group"
                                        options={groups}
                                        name="telegram_group_id"
                                        {...form}
                                    />
                                    :
                                    <div className=" mb-4">
                                        <label className="paylixecommerce-label " htmlFor="telegram_group_id">
                                            {GroupLabel}
                                        </label>
                                        <p className="paylixecommerce-note" style={{ marginTop: "-.5rem" }}>
                                            No groups are currently connected. Please follow <a href="https://help.paylix.gg/en/articles/8707678-how-to-use-our-telegram-bot" target="_blank">the guide</a> to add groups and click the refresh button.
                                        </p>
                                    </div>
                            }

                            {!!telegramServerError &&
                                <div style={{marginTop: "-.75rem"}} className="invalid-feedback d-flex w-100">
                                    {telegramServerError}
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>

    </div>
}